"use client";

import Image from "next/image";
import data from "@/public/data/error.json";
import { Button } from "@/shared/components/common/button/Button";
import Container from "@/shared/components/common/Container";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import { useEffect } from "react";
import errorImage from "@/public/svg/error.svg";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { title, description, resetApp, redirect } = data;

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <Flex className="bg-muted">
      <Container className="py-20">
        <Flex className="flex-col gap-y-10">
          <Flex className="place-content-center">
            <Image
              src={errorImage}
              className="w-1/3 max-md:w-3/5 h-auto"
              width={500}
              height={500}
              alt="404"
            />
          </Flex>

          <Flex className="flex-col items-center gap-y-6">
            <Flex className="flex-col items-center gap-2">
              <Typography variant="h3" className="font-normal text-foreground">
                {title}
              </Typography>
              <Typography className="font-normal text-grayColor-foreground max-w-[70%] text-center leading-7">
                {description}
              </Typography>
            </Flex>

            <Flex className="gap-x-4">
              <Button
                className="p-2 border-2 border-destructive !bg-destructive hover:!bg-transparent hover:!text-destructive"
                onClick={reset}
              >
                <Typography>{resetApp}</Typography>
              </Button>
              <Button className="p-2 border-2 border-primary hover:bg-transparent hover:!text-primary">
                <Link href={"/"}>
                  <Typography>{redirect}</Typography>
                </Link>
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Container>
    </Flex>
  );
}
